import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { Container, makeStyles } from '@material-ui/core';

import Page from 'src/shared/ui/components/Page';
import Datatable from 'src/shared/ui/components/Datatable';

import getContractTypeList from 'src/contract-type/use-cases/getContractTypeList';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  }
}));

const ContractTypeListView = () => {
  const companyHeadquarterId = localStorage.selectedUserHeadquarter;
  const classes = useStyles();

  const [list, setList] = useState({
    rows: [],
    count: 0
  });
  const [search, setSearch] = useState('');
  const [page, setPage] = useState(0);
  const [limit, setLimit] = useState(10);
  const [orderBy, setOrderBy] = useState({
    columnName: null,
    orderBy: null
  });

  const navigate = useNavigate();

  const fetchList = async () => {
    const contractTypeList = await getContractTypeList({
      companyHeadquarterId,
      search,
      orderBy: orderBy.columnName
        ? `${orderBy.columnName} ${orderBy.orderBy}`
        : '',
      page,
      limit
    });

    setList(contractTypeList);
  };

  useEffect(() => {
    fetchList();
  }, [page, limit, search, orderBy]);

  const handleSearch = (searchValue) => {
    setPage(0);
    setSearch(searchValue.target.value);
  };

  const handleChangePage = (pageIndex) => {
    setPage(pageIndex);
  };

  const handleChangeLimit = (limitIndex) => {
    setLimit(limitIndex);
  };

  const handleOrderBy = (column) => {
    setOrderBy(column);
  };

  const handleClickEdit = (event, id) => {
    navigate(`/app/contract-types/${id}`, {
      replace: false
    });
  };

  const columnNameList = [
    'createdAt',
    'name',
    'totalDuration',
    'price',
    'promoDuration',
    'discountPercentage'
  ];

  return (
    <Page className={classes.root} title="Tipos de contratos">
      <Container maxWidth={false}>
        <Datatable
          domainName="CONTRACT_TYPE"
          dataList={list.rows}
          count={list.count}
          title="Tipos de contratos"
          addButtonText="Añadir tipo de contrato"
          addButtonRoute="/app/contract-types/new"
          exportExcelButton={Boolean(false)}
          onSearch={handleSearch}
          onChangePageValue={handleChangePage}
          onChangePageLimit={handleChangeLimit}
          handleOrderBy={handleOrderBy}
          handleClickEdit={handleClickEdit}
          columnNameList={columnNameList}
        />
      </Container>
    </Page>
  );
};

export default ContractTypeListView;
